
namespace GeniuzPOS.InitialData {

    @Serenity.Decorators.registerClass()
    export class PsCashierDialog extends Serenity.EntityDialog<PsCashierRow, any> {
        protected getFormKey() { return PsCashierForm.formKey; }
        protected getIdProperty() { return PsCashierRow.idProperty; }
        protected getLocalTextPrefix() { return PsCashierRow.localTextPrefix; }
        protected getNameProperty() { return PsCashierRow.nameProperty; }
        protected getService() { return PsCashierService.baseUrl; }
        protected getDeletePermission() { return PsCashierRow.deletePermission; }
        protected getInsertPermission() { return PsCashierRow.insertPermission; }
        protected getUpdatePermission() { return PsCashierRow.updatePermission; }

        protected form = new PsCashierForm(this.idPrefix);
        protected afterLoadEntity() {
            super.afterLoadEntity();

            var CashierId = Q.tryFirst(PosShift.PsPosShiftControlRow.getLookup().items, x => x.CashierId == this.entity.CashierId);
            if (CashierId != null) {
                this.deleteButton.toggleClass('disabled', true);

            }
        }
    }
}